module.exports = __webpack_public_path__ + "static/media/vu.1610dfa2.svg";